module.exports = "<div>Sensor Component</div>\n\n\n"